module.exports = __webpack_public_path__ + "ai-bot-body-think1wp50760bf59969ef07a6c164ce4d46bc73.png";